import { ProfilePhotos } from '@/screens/profile-photos';

export default function ProfilePhotosScreen() {
  return <ProfilePhotos />;
}
